export default __webpack_public_path__ + "static/media/ARU.93b9738b.svg";